"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _default = (0, _createReactClass.default)({
  render: function render() {
    return _react.default.createElement("div", {
      className: "duration-picker width-100"
    }, _react.default.createElement(_H.default, {
      className: "skeleton-text"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "prebook.durationPicker.header"
    })), _react.default.createElement("div", {
      className: "skeleton m-top-8 m-bottom-12"
    }));
  }
});

exports.default = _default;
module.exports = exports.default;